import { useMemo, useCallback } from 'react'
import { Box, SvgIcon, Link } from '@applift/factor'
import { StatusPending, StatusReady } from '@applift/icons'
import {
  CmpConversion,
  CmpConversionSelectItem,
  Conversion,
} from '../../models/Conversion'
import { TestPixel } from '../../models/Pixel'

interface StatusCellProps {
  conversion: Conversion | CmpConversion | CmpConversionSelectItem
  handleTestConversion?: (conversionTest: TestPixel) => void
}

export const StatusCell = (props: StatusCellProps) => {
  const { handleTestConversion, conversion } = props
  const { status, id, name, type = null } = conversion as Conversion

  const handleClick = useCallback(() => {
    if (handleTestConversion) {
      handleTestConversion({
        action: status?.toLowerCase() === 'active' ? 'retest' : 'test',
        name,
        id,
      })
    }
  }, [status, name, id, handleTestConversion])

  const testButton = useMemo(
    () => (
      <>
        {!!handleTestConversion && (
          <Link
            Component="button"
            color="primary"
            underline="none"
            onClick={handleClick}
          >
            {status?.toLowerCase() === 'active' ? 'Retest' : 'Test'}
          </Link>
        )}
      </>
    ),
    [status, handleClick, handleTestConversion]
  )

  if (!status || type?.toLowerCase() === 'postback') {
    return <>-</>
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'between',
        width: 100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
        }}
      >
        <SvgIcon
          sx={{ mr: 8 }}
          color={status.toLowerCase() === 'pending' ? 'warning' : 'info'}
        >
          <>
            {status.toLowerCase() === 'pending' ? (
              <>
                <StatusPending />
              </>
            ) : (
              <>
                <StatusReady />
              </>
            )}
          </>
        </SvgIcon>
        <>{`${status.charAt(0).toUpperCase()}${status.slice(1)}`}</>
      </Box>
      <>{testButton}</>
    </Box>
  )
}
